import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HeroSection from "./components/HeroSection";
import SpecialsSection from "./components/SpecialsSection";
import ValentineGifts from "./components/ValentineGifts";
import CategorySection from "./components/CategorySection";
import CustomizeSection from "./components/CustomizeSection";
import LocationsSection from "./components/LocationsSection";
import "./index.css";

function HomePage() {
  return (
    <>
      <HeroSection />
      <SpecialsSection />
      <ValentineGifts />
      <CategorySection />
      <CustomizeSection />
      <LocationsSection />
    </>
  );
}

function App() {
  return (
    <ThemeProvider>
      <div className="min-h-screen bg-[#1a1a2e]">
        <BrowserRouter>
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
            </Routes>
          </main>
          <Footer />
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
